import { AddSessionModal } from "components/SessionForm";
import { usePermissions } from "layouts/Admin";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "reactstrap";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup, setAddAppointmentPopup } from "slices/appointmentSlice";
import { fetchDashboardAnalytics } from "slices/dashboardSlice";
import { fetchDashboardAppointments } from "slices/dashboardSlice";

let userSlice;
function Header(props) {
  const [color] = React.useState("transparent");
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);

  const refDropdown = React.useRef(null);

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    dispatch(userSlice.logout());
    navigate("/login", { replace: true });
  };

  const handleClose = () => {
    dispatch(closeAppointmentPopup());
  };

  const callback = () => {
    handleClose();
    appointmentPopUpState?.callback && appointmentPopUpState?.callback();
    dispatch(fetchDashboardAnalytics());
    dispatch(fetchDashboardAppointments());
  };

  const handleAddAppointmentPopUp = (item) => {
    dispatch(
      setAddAppointmentPopup({
        show: true,
        item,
      })
    );
  };

  return (
    <Navbar
      expand="lg"
      className={`px-2 py-3
        ${location.pathname.indexOf("full-screen-maps") !== -1
          ? "navbar-absolute border-0 fixed-top"
          : "navbar-absolute border-0 fixed-top " +
          (color === "transparent" ? "navbar-transparent " : "")}
      `}
    >
      <div className="header">
        <div className="welcome_text">
          <h2>Hello Admin!</h2>
          <p>Smart Insights for Smarter Interpretations</p>
        </div>
        <div className="row_user_side">
          <button type='button' className='main_button' onClick={() => handleAddAppointmentPopUp()}>Add Session</button>
          {/* <div ref={refDropdown} className="position-relative">
            <button className="notification" onClick={toggleDropdown}>
              <img src="/images/bell.png" alt="" />
            </button>
            <div className={`drop_more_selector ${dropdownOpen ? "active" : ""}`}>
              <ul>
                <li>
                  <Link href="#!">Notification</Link>
                </li>
                <li>
                  <Link href="#!">Notification</Link>
                </li>
                <li>
                  <Link href="#!">Notification</Link>
                </li>
                <li>
                  <Link href="#!">Notification</Link>
                </li>
              </ul>
            </div>
          </div> */}
          <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
            <div className="user_image" >
              <img src="/images/default-person.png" alt="" />
            </div>
            <h3>Admin</h3>
          </div>
        </div>
      </div>

      <AddSessionModal
        show={appointmentPopUpState.show}
        item={appointmentPopUpState.item}
        onClose={handleClose}
        afterUpdated={callback}

      />
    </Navbar>
  );
}

export default Header;
